<footer class="footer-custom">
  <div class="container footer-container">
    <!-- LEFT -->
    <div class="footer-left">
      <div class="copyright">
        <strong>UPA-TIK</strong> Copyright © {{ currentYear }}
        <a href="https://unej.ac.id" target="_blank">
          Library University of Jember
        </a>
      </div>

      <div class="footer-links">
        <a href="/page/contact">Contact Us</a>
        |
        <a href="/page/feedback">Send Feedback</a>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="footer-right">
      <div class="footer-title">
        Indonesia DSpace Group :
      </div>

      <ul class="footer-list">
        <li>
          <a href="https://repository.unej.ac.id" target="_blank">
            University of Jember Repository
          </a>
        </li>
        <li>
          <a href="https://repository.ipb.ac.id" target="_blank">
            IPB University Scientific Repository
          </a>
        </li>
        <li>
          <a href="https://repository.uinjkt.ac.id" target="_blank">
            UIN Syarif Hidayatullah Institutional Repository
          </a>
        </li>
      </ul>
    </div>
  </div>
</footer>
